import { useStage } from './useStage'

export default () => useStage('facial-enrollment')
